<template>
  <div class="qaqc-test-plot-wrapper">
    <div class="qaqc-test-chart-name-top">
      <h6>QC Status Overview</h6>
      <div class="qaqc-test-header-actions">
       
      </div>
    </div>
    <div class="qaqc-test-plots-content">
      <div ref="chartContainer" class="qaqc-test-main-chart qaqc-status-bar-chart"></div>
      <div class="qaqc-overview-chart-legend" v-if="(data.series || []).length">
        <span
          v-for="s in data.series"
          :key="s.name"
          class="qaqc-legend-item"
        >
          <span class="qaqc-legend-dot" :style="{ backgroundColor: s.color }"></span>
          {{ s.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Plotly from "plotly.js-dist-min";

export default {
  name: "QCStatusOverviewChart",
  props: {
    data: {
      type: Object,
      default: () => ({
        categories: [],
        series: [],
      }),
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.$nextTick(() => this.renderChart());
      },
    },
  },
  mounted() {
    this.renderChart();
  },
  beforeUnmount() {
    if (this.$refs.chartContainer) {
      try {
        Plotly.purge(this.$refs.chartContainer);
      } catch (_) {}
    }
  },
  methods: {
    renderChart() {
      if (!this.$refs.chartContainer) return;
      const categories = this.data.categories || [];
      const series = this.data.series || [];
      if (categories.length === 0 || series.length === 0) return;
      const traces = series.map((s) => ({
        x: categories,
        y: s.values || [],
        name: s.name,
        type: "bar",
        marker: { color: s.color || "#2298D5" },
      }));
      const layout = {
        margin: { t: 8, r: 24, b: 48, l: 56 },
        showlegend: false,
        xaxis: { title: "", tickfont: { size: 12 } },
        yaxis: { title: "", tickfont: { size: 11 }, rangemode: "tozero" },
        barmode: "group",
        bargap: 0.25,
        bargroupgap: 0.05,
        paper_bgcolor: "transparent",
        plot_bgcolor: "transparent",
      };
      const config = { responsive: true, displayModeBar: false };
      Plotly.react(this.$refs.chartContainer, traces, layout, config);
    },
  },
};
</script>
